import React from "react";

import { Switch, Route } from "react-router-dom";

import InvoiceProcessingPage from "./InvoiceProcessingPage";

const InvoiceProcessingRouter = () => (
  <Switch>
    <Route path="/finance/invoice-processing">
      <InvoiceProcessingPage />
    </Route>
  </Switch>
);

export default InvoiceProcessingRouter;
